module.exports = vendors_572a6ecc625a703de45e;